import { render, staticRenderFns } from "./MedicalRequirementsPlanRaysAdd.vue?vue&type=template&id=5dde8b72&scoped=true&"
import script from "./MedicalRequirementsPlanRaysAdd.vue?vue&type=script&lang=js&"
export * from "./MedicalRequirementsPlanRaysAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dde8b72",
  null
  
)

export default component.exports